import { useCallback, useState } from 'react';
import { InputFieldState } from '@servicetitan/form-state';
import { useScreenSize } from '@servicetitan/design-system';

export const useFormInputs = (defaultWidth?: number) => {
    const [inputsTouched, setInputsTouched] = useState(false);

    const wrapChangeHandler = useCallback(
        (handler: Function) =>
            (...args: any[]) => {
                setInputsTouched(true);

                handler(...args);
            },
        [],
    );

    const screenSize = useScreenSize();

    const width = screenSize.smallerThan.tablet ? undefined : defaultWidth;

    return {
        inputsTouched,
        getInputProps: (fieldState: InputFieldState<string>) => {
            const { value, error, onChangeNativeHandler, enableAutoValidationAndValidate } =
                fieldState;

            return {
                value,
                error,
                width,
                onBlur: enableAutoValidationAndValidate,
                onChange: wrapChangeHandler(onChangeNativeHandler),
            };
        },
    };
};
